<template>
  <v-dialog hide-overlay max-width="800px" v-model="show">
    <v-card>
      <v-card-title
        >{{ mode === 'edit' ? '修改' : '新增' }} Module
      </v-card-title>
      <v-card-actions>
        <v-btn @click="update" :disabled="!valid" v-if="mode === 'edit'"
          >修改</v-btn
        >
        <v-btn @click="save" :disabled="!valid" v-else>保存</v-btn>

        <v-btn @click="close">戻る</v-btn>
      </v-card-actions>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                label="group"
                v-model="moduleMap.description"
                :rules="[(v) => !!v || `description is required`]"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="module_code"
                v-model="moduleMap.module_code"
                :disabled="mode === 'edit'"
                :rules="[(v) => !!v || `module_code is required`]"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="module_name"
                v-model="moduleMap.module_name"
                :rules="[(v) => !!v || `module_name is required`]"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return { selecetd: '', show: false, moduleMap: {}, valid: false, mode: '' }
  },
  methods: {
    close() {
      this.show = false
    },
    popupNew(module) {
      this.show = true
      this.moduleMap = { ...module }
      this.mode = 'new'
    },
    popupEdit(module) {
      this.popupNew(module)
      this.mode = 'edit'
    },
    save() {
      this.$http
        .post('/basic-data/sys-modules', {
          ...this.moduleMap,
          application_code: 'SHARP',
          parent_module_id: '',
          standard_code: '',
        })
        .then((res) => {
          if (res.data.ret_code === '00000') {
            this.$message('', this.$t('app.messages.saveSuccess'))
          } else {
            this.$message('', `${res.data.ret_code}: ${res.data.ret_msg}`)
          }
          this.$emit('refresh')
          this.close()
        })
        .catch((res) => {
          this.$message(
            '',
            `${res.response.data.ret_code}: ${res.response.data.ret_msg}`
          )
        })
    },
    update() {
      this.$http
        .patch('/basic-data/sys-modules', {
          module_id: this.moduleMap.module_id,
          description: this.moduleMap.description,
          module_name: this.moduleMap.module_name,
        })
        .then((res) => {
          if (res.data.ret_code === '00000') {
            this.$message('', this.$t('app.messages.saveSuccess'))
          } else {
            this.$message('', `${res.data.ret_code}: ${res.data.ret_msg}`)
          }
          this.$emit('refresh')
          this.close()
        })
        .catch((res) => {
          this.$message(
            '',
            `${res.response.data.ret_code}: ${res.response.data.ret_msg}`
          )
        })
    },
  },
}
</script>

<style>
.select-area {
  border: 2px solid #000;
  height: 300px;
}
</style>
